import './section-careers.scss';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';
import 'owl.carousel';

import ScrollMagic from 'scrollmagic';

export default (() => {
	$(document).ready(function () {
		if ($('.section--careers').length > 0) {
			$('.careers').owlCarousel({
				items: 1,
				loop: true,
				nav: false,
				center: true,
				margin: 40,
				dots: true,
				stagePadding: 10,
				onInitialized: carouselDragHandler,
				onTranslated: carouselDragHandler,
				responsive: {
					480: {
						margin: 40,
						stagePadding: 60
					},
					768: {
						margin: 50,
						stagePadding: 150,
						nav: true
					},
					920: {
						margin: 50,
						stagePadding: 200,
						nav: true
					},
					1024: {
						stagePadding: 300,
						margin: 70,
						nav: true
					},
					1366: {
						stagePadding: 450,
						nav: true
					},
					1600: {
						stagePadding: 500,
						nav: true
					},
					2000: {
						items: 3,
						stagePadding: 200,
						nav: true
					}
				}
			});

			const controller = new ScrollMagic.Controller();
			// careers animation
			const section = document.querySelector('.section--careers');
			new ScrollMagic.Scene({
				triggerElement: section,
				triggerHook: '0.7'
			})
				.on('enter', e => {
					section.classList.add('colored');
					section.querySelector('.title').classList.add('title--completed');
					$(section.querySelector('.careers')).css({
						animation: 'animation: fade-down .25s linear forwards'
					});
					$(section.querySelector('.button')).css({
						animation: 'animation: fade-down .25s linear forwards'
					});
				})
				.on('leave', e => {
					section.classList.remove('colored');
					section.querySelector('.title').classList.remove('title--completed');
					$(section.querySelector('.careers')).css({
						animation: ''
					});
					$(section.querySelector('.button')).css({
						animation: ''
					});
				})
				.addTo(controller);
			new ScrollMagic.Scene({
				triggerElement: section,
				triggerHook: '0.1'
			})
				.on('enter', e => {
					if ($('#careers').length > 0) {
						document.querySelector('.header__menu').classList.remove('header__menu--white');
						document.querySelector('.header__menu').classList.add('header__menu--yellow');
					}
				})
				.on('leave', e => {
					if ($('#careers').length > 0) {
						document.querySelector('.header__menu').classList.remove('header__menu--yellow');
						document.querySelector('.header__menu').classList.add('header__menu--white');
					}
				})
				// .addIndicators()
				.addTo(controller);
		}
	});

	function carouselDragHandler () {
		$('.careers .owl-item').each(function () {
			if (!$(this).hasClass('center')) {
				$(this).children().css('cursor', 'default');
				$(this).click(function (e) {
					if (!$(e.currentTarget).hasClass('center')) e.preventDefault();
				});
			} else {
				$(this).children().css('cursor', 'pointer');
			};
		});
	}
})();
